<template>
  <section class="clinical-trials-module-component">
    <div class="inner-container">
      <h2 v-html="props.data.title"></h2>

      <div class="trials">
        <div
          v-for="(trial, idx) in data.trials"
          :key="`trial-${idx}`"
          class="trial">
          <div class="action-container">
            <p
              class="category"
              v-html="trial.category"></p>

            <h3 v-html="trial.title"></h3>
            <div class="arrow-container">
              <Arrow
                :direction="openStates[idx] ? 'up' : 'down'"
                @click="toggleIndex(idx)" />
            </div>
          </div>

          <Vue3SlideUpDown
            :key="idx"
            v-model="openStates[idx]"
            :duration="1000">
            <p class="summary-title">Summary</p>
            <div
              class="summary"
              v-html="trial.summary"></div>
            <ArrowCircleButton
              v-if="trial.link"
              :link="trial.link" />
          </Vue3SlideUpDown>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "ClinicalTrialsComponent",
  "CLASSNAME": "clinical-trials-module-component",
  "URL": "http://vuevitewp.local/"
 }
#ENDMETA */

/*
 *   Insert your logic here
 */
import { ref, onMounted } from 'vue'
import { Vue3SlideUpDown } from 'vue3-slide-up-down'
import Arrow from '../utility/Arrow.vue'
import ArrowCircleButton from '@/components/utility/ArrowCircleButton.vue'

const props = defineProps(['data'])

const openStates = ref([])
const trials = ref([...props.data.trials])

onMounted(() => {
  openStates.value = trials.value.map(() => true)
})

const toggleIndex = (idx) => {
  openStates.value[idx] = !openStates.value[idx]
}
</script>

<style lang="scss">
.clinical-trials-module-component {
  @apply relative bg-bicara-white py-xl;

  .inner-container {
    @apply px-xs xl:px-xl;

    h2 {
      @apply header-5 mb-5 ml-3 text-bicara-charcoal lg:ml-0;
    }

    .trials {
      @apply flex flex-col gap-4 rounded-2xl border border-bicara-dark-blue px-4 py-lg lg:px-8 lg:py-11;

      .trial {
        + .trial {
          @apply border-t-[1px] border-bicara-dark-blue pt-5;
        }

        .action-container {
          @apply relative flex flex-col gap-3 pb-16 lg:pb-0 lg:pr-32;

          .category {
            @apply body-md mb-2 text-bicara-charcoal;
          }

          h3 {
            @apply header-5 font-medium text-bicara-dark-blue;
          }

          .arrow-container {
            @apply absolute bottom-0 right-0 flex justify-end lg:bottom-auto lg:top-0;

            .arrow-circle {
              @apply h-[45px] w-[45px];

              .circle-container {
                @apply p-3;
              }
            }
          }
        }

        .summary-title {
          @apply body-md mt-5 text-bicara-blue;
        }

        .summary {
          @apply body-sm;
        }
      }
    }
  }
}
</style>
